import { render, staticRenderFns } from "./RepairOrderDetail.vue?vue&type=template&id=2e7a153e&scoped=true&"
import script from "./RepairOrderDetail.vue?vue&type=script&lang=js&"
export * from "./RepairOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7a153e",
  null
  
)

export default component.exports